const LocateMeIcon = ({ color }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    data-testid="truck-unlock"
  >
    <title>a-icons / 32px / services / truck unjamming</title>
    <g fill="none" fillRule="evenodd">
      <g fill={color || '#00008F'} fillRule="nonzero">
        <path
          d="M61.645 342.068c-.181-.09-.395-.09-.576 0l-16.714 8.357c-.317.159-.446.545-.287.863.09.18.26.308.46.344l6.633 1.207 1.207 6.633c.049.272.267.482.54.522.03.004.06.006.091.006.244 0 .467-.138.576-.356l8.357-16.713c.159-.318.03-.704-.287-.863zm-8.358 15.276l-.941-5.173c-.049-.261-.253-.466-.515-.514l-5.176-.944 13.264-6.632-6.632 13.263z"
          transform="translate(-44 -342)"
        />
      </g>
    </g>
  </svg>
);

export default LocateMeIcon;
